import clientFetcher from '@finance/clientFetcher';
import { Temporal } from '@js-temporal/polyfill';
import { Document } from 'fluent-graphql';
import type { Errors, Revenue, TypedObject } from '../types';

export interface CreateRevenueReturn {
  createRevenue: Revenue | { reference: string } & TypedObject | Errors;
}

interface CreateRevenueVars {
  organizationId: string;
  input: unknown;
}

export default Document
  .mutation<CreateRevenueReturn, CreateRevenueVars>('CreateRevenue')
    .variableDefinitions({ organizationId: 'ID!', input: 'CreateRevenueInput!' })
    .union('createRevenue')
      .useVariables({ organizationId: 'organizationId', input: 'input' })
      .onEntity('Revenue')
        .scalar('organizationId')
        .scalar('date', Temporal.PlainDate.from)
        .reference('currencyId', 'Currency')
        .reference('revenueTypeId', 'RevenueType')
        .reference('accountId', 'Account')
        .reference('walletId', 'Wallet')
        .scalar('amountBeforeAllocations')
        .scalar('amountAfterAllocations')
        .scalar('description')
        .scalar('reference')._
      .onTypedObject('NonZeroArchivedWalletBalance')
        .scalar('name')._
      .onTypedObject('RevenueAllocationsExceedRevenue')
        .scalar('revenueAmount')
        .scalar('currencyName')._
      .onTypedObject('ReferenceAlreadyUsed')
        .scalar('reference')._
      .onTypedObject('InputErrors')
        .scalar('errors')._._._
  .makeExecutable(clientFetcher)
  .afterExecution(({ createRevenue: data }) => {
    if (data.__typename === 'Revenue') {
      Document.clearQueries([
        'Revenues',
        'WalletTransfers',
        'WalletTransactions',
        'AccountTransactions',
        'Wallets',
        'Accounts'
      ]);
    }
  });
